<div
  class="no-scroll-x no-scroll-y wf-icons-wrapper"
  #iconsContainer
  [class.wf-icons-list-right]="allignment === 'right'"
>
  <ng-content></ng-content>

  <span
    class="wf-icon-container wf-icon-badge"
    #iconBadge
    *ngIf="overflowIcons && overflowIcons.length"
    (mouseenter)="showTooltip()"
    (mouseleave)="hideTooltip()"
  >
    <span class="wf-icon-badge-text"> +{{ overflowIcons.length }} </span>
  </span>
</div>

<ng-template #iconTooltip let-overflowIcons="overflowIcons">
  <div class="wf-icons-list-tooltip-container">
    <div class="tooltip wf-icons-list-tooltip">
      <div class="tooltip__content">
        <ul class="wf-icons-list list--none u-p0 u-m0">
          <li
            class="u-mv-- flex flex--row flex--nowrap"
            *ngFor="let icon of overflowIcons; first as first; last as last"
            [class.u-mv--]="!first && !last"
            [class.u-mb--]="first && !last"
            [class.u-mt--]="!first && last"
          >
            <div class="u-mr--- wf-icons-list-icon">
              <svg-icon
                *ngIf="!icon.hidden"
                [name]="icon.icon"
                [svgStyle]="{ 'width.px': 16, 'height.px': 16, fill: icon.fillColor || 'currentColor' }"
                [ngClass]="icon.class"
                [attr.name]="icon.icon"
              >
              </svg-icon>
            </div>
            <div class="flex--item--auto">
              <ng-container *ngIf="icon.tooltip | isTemplateRef; else defaultTemplate">
                <ng-container
                  [ngTemplateOutlet]="icon.tooltip"
                  [ngTemplateOutletContext]="{ data: icon.tooltipData }"
                ></ng-container>
              </ng-container>
              <ng-template #defaultTemplate>
                <div [innerHTML]="icon.tooltip || icon.label"></div>
              </ng-template>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</ng-template>
